/** @format */

export enum LoggerLevel {
	TRACE = 0,
	DEBUG,
	INFO,
	LOG,
	WARN,
	ERROR,
	OFF
}
